import GrupoUsuarios from "model/administracao/cadastro/GrupoUsuarios";
import DocumentoPastaAcao from "./DocumentoPastaAcao";

export default class DocumentoPastaAcessoGrupo {
    grupo: GrupoUsuarios; 
    acoes: DocumentoPastaAcao[];

    constructor(grupo: GrupoUsuarios, acoes: DocumentoPastaAcao[]) {
        this.grupo = grupo;
        this.acoes = acoes;
    }
}